import styled from '@emotion/styled';
import { Ui } from '@silvertours/front-shared';

export const Image = styled(Ui.Image)`
  max-width: 100%;
  height: auto;
`;
